import { useEffect, useState } from "react";
import { Spinner } from "@/components/ds";
import { TeamList } from "@/components/app/team/TeamList";
import { usePageTitle } from "../hooks/usePageTitle";
import type { TeamMember } from "@/domain/team/types";
import type { Invite } from "@/domain/team/types";

export function TeamPage() {
  usePageTitle("Team | TidyRota");
  const [data, setData] = useState<{ members: TeamMember[]; invites: Invite[] } | null>(null);

  useEffect(() => {
    fetch("/api/team")
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          setData(json.data);
        }
      });
  }, []);

  if (data === null) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "var(--space-10)" }}>
        <Spinner />
      </div>
    );
  }

  return <TeamList initialMembers={data.members} initialInvites={data.invites} />;
}
